/* Listicle acne: pasek na dole znika, gdy widać przycisk bloku oferty. Tylko atrybut, bez zmian treści. */
(function () {
  var pasek = document.querySelector('.lst-pasek');
  var cel = document.querySelector('.lst-offer .lst-btn');
  if (!pasek || !cel || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (w) {
    pasek.setAttribute('data-ukryty', w[0].isIntersecting ? '1' : '0');
  }).observe(cel);
})();
